var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "searchable-select"
  }, [_c('input', {
    staticStyle: {
      "position": "absolute",
      "opacity": "0",
      "height": "0",
      "width": "0",
      "pointer-events": "none"
    },
    attrs: {
      "type": "text",
      "required": _vm.required,
      "tabindex": "-1"
    },
    domProps: {
      "value": _vm.value
    }
  }), _c('b-button', {
    class: {
      'is-invalid': _vm.required && !_vm.value
    },
    attrs: {
      "id": "searchable-select-".concat(_vm._uid),
      "disabled": _vm.disabled,
      "variant": _vm.variant,
      "size": _vm.size,
      "block": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('span', {
    class: {
      'text-muted': !_vm.selectedText
    }
  }, [_vm._v(" " + _vm._s(_vm.selectedText || _vm.placeholder) + " ")]), _c('i', {
    staticClass: "fa fa-chevron-down ml-2"
  })])]), _c('b-popover', {
    attrs: {
      "target": "searchable-select-".concat(_vm._uid),
      "triggers": "focus",
      "placement": "bottom",
      "show": _vm.showPopover,
      "custom-class": "searchable-select-popover"
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showPopover = $event;
      },
      "shown": _vm.onShown,
      "hidden": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "popover-content"
  }, [_c('b-form-input', {
    ref: "searchInput",
    staticClass: "mb-2",
    attrs: {
      "type": "text",
      "placeholder": "Search...",
      "size": "sm",
      "autocomplete": "off"
    },
    model: {
      value: _vm.searchQuery,
      callback: function callback($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  }), _c('div', {
    staticClass: "options-container"
  }, [_vm._l(_vm.filteredOptions, function (option) {
    return _c('div', {
      key: option[_vm.valueField],
      staticClass: "option-item",
      class: {
        active: _vm.value === option[_vm.valueField]
      },
      on: {
        "click": function click($event) {
          return _vm.selectOption(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option[_vm.textField]) + " ")]);
  }), _vm.filteredOptions.length === 0 ? _c('div', {
    staticClass: "text-muted text-center py-2"
  }, [_vm._v(" No results found ")]) : _vm._e()], 2)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }